import React from 'react';
import App from './components/App';
import './index.css';

export default App; 

